import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Container, Segment, Header, Table, List, Popup, Label } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { base } from '../../../config/constants';

import { AlertBox, setAlertMsg } from '../../../components/Modals';

const getUserLabelContent = (email) => {
  if (!email) {
    return null;
  }
  return (
    <Popup
      trigger={
        <Header
          content={email.toUpperCase()}
          size="tiny"
        />
      }
    >
      <Popup.Content>{email}</Popup.Content>
    </Popup>
  );
};

const getFormattedList = (themes, fullAccess = false) => {
  if ((!themes || Object.keys(themes).length < 1) && !fullAccess) {
    return '-';
  }
  // console.log(themes, fullAccess);

  if (fullAccess) {
    return (<Label color="red" content="ACCES TOTAL" />);
  }
  const themesList = Object.keys(themes);

  return themesList.length === 1
    ? (
      <Label content={themesList[0].toUpperCase()} />
    )
    : (
      <Popup
        trigger={<Label color="orange">{themesList.length}</Label>}
        position="right center"
        // inverted
      >
        <List>
          {
            _.map(themesList, theme => (
              <List.Item key={theme}>
                <List.Content>
                  <Label content={theme.toUpperCase()} />
                </List.Content>
              </List.Item>
            ))
          }
        </List>
      </Popup>
    );
};

export default class ListRecipients extends Component {
  static propTypes = {
    habilitations: PropTypes.object,
  }

  static defaultProps = {
    habilitations: {
      superuser: false,
      themes: {},
      citizenly: {},
      elected: {},
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      // selectedAdmin: null,
      listenersLoading: true,
      recipients: [],
    };
  }

  componentDidMount() {
    if (this.props.habilitations.superuser) {
      // bind unitaire pour toutes
      base.bindToState('users', {
        context: this,
        state: 'recipients',
        asArray: true,
        queries: {
          orderByChild: 'email',
          startAt: '',
        },
        then() {
          this.setState({
            listenersLoading: false,
          });
        },
        onFailure(error) {
          // console.log('error');
          this.setState(setAlertMsg(
            null,
            'Impossible de récupérer la liste des destinataires',
            error.toString(),
            'error',
          ));
        },
      });
    } else {
      base.listenTo('users', {
        context: this,
        asArray: true,
        queries: {
          orderByChild: 'email',
          startAt: '',
        },
        then(recipientsData) {
          const themesHab = this.props.habilitations.themes
            ? Object.keys(this.props.habilitations.themes) : false;
          const citizenlyHab = this.props.habilitations.citizenly
            ? Object.keys(this.props.habilitations.citizenly) : false;
          const electedHab = this.props.habilitations.elected
            ? Object.keys(this.props.habilitations.elected) : false;
          if (recipientsData.length > 0) {
            const filteredList = _.filter(recipientsData, (recipient) => {
              if (themesHab && recipient.themes
                && _.intersection(themesHab, Object.keys(recipient.themes)).length > 0) {
                return true;
              }
              if (citizenlyHab && recipient.citizenly
                && _.intersection(citizenlyHab, Object.keys(recipient.citizenly)).length > 0) {
                return true;
              }
              if (electedHab && recipient.elected
                && _.intersection(electedHab, Object.keys(recipient.elected)).length > 0) {
                return true;
              }
              return false;
            });
            this.setState({
              recipients: filteredList,
              listenersLoading: false,
            });
          } else {
            this.setState({
              listenersLoading: false,
            });
          }
        },
      });
    }
  }


  render() {
    // console.log('admins', this.state.admins);
    return (
      <Container>
        <Segment basic loading={this.state.listenersLoading}>
          <Table
            compact
            selectable
            stackable
            // sortable
            tableData={_.filter(this.state.recipients, u => u.email)}
            headerRow={
              <Table.Row>
                <Table.HeaderCell>
                  Identifiant
                </Table.HeaderCell>
                <Table.HeaderCell>Profession</Table.HeaderCell>
                <Table.HeaderCell>Commune</Table.HeaderCell>
                <Table.HeaderCell>Circonscription</Table.HeaderCell>
              </Table.Row>
            }
            footerRow={this.state.recipients.length === 0 ?
              (
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center" disabled>
                    <Segment basic padded="very">
                      Aucun administrateur ne peut être affiché
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              ) : null}
            renderBodyRow={data => (
              <Table.Row key={data.key}>
                <Table.Cell>
                  <Link to={`/recipients/edit/${data.key}`}>
                    {getUserLabelContent(data.email)}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/recipients/edit/${data.key}`}>
                    {data ? getFormattedList(data.themes, data.fullAccess && data.fullAccess.themes) : null}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/recipients/edit/${data.key}`}>
                    {data ? getFormattedList(data.citizenly, data.fullAccess && data.fullAccess.citizenly) : null}
                  </Link>
                </Table.Cell>
                <Table.Cell>
                  <Link to={`/recipients/edit/${data.key}`}>
                    {data ? getFormattedList(data.elected, data.fullAccess && data.fullAccess.elected) : null}
                  </Link>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Recipients/ListRecipients.js